<template>
  <img
    v-if="shareableLinkLogo?.mode === 'custom' && shareableLinkLogo?.url"
    :src="shareableLinkLogo.url"
    alt="Logo"
    :class="logoSizeClass"
    class="max-w-[200px] object-contain object-left"
  />
  <img
    v-else
    :src="logo"
    :alt="alt"
    :class="logoSizeClass"
  />
</template>
<script>
import GpxLogo from '@/assets/gpx-logo.svg';
import LogistimaticsLogo from '@/assets/logo.webp';
import LogistimaticsForbidden from '@/assets/logo.png';

import { is_b2b_platform } from '@/utils/b2b-account';

export default {
  props: {
    forbidden: {
      type: Boolean,
      default: false,
    },
    shareableLinkLogo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    is_b2b_platform() {
      return is_b2b_platform;
    },
    logoSizeClass() {
      return this.is_b2b_platform ? 'h-[18px] md:h-[28px]' : 'h-[30px] md:h-[40px]';
    },
    logo() {
      if (is_b2b_platform) {
        return GpxLogo;
      }

      if (this.forbidden) {
        return LogistimaticsForbidden;
      }

      return LogistimaticsLogo;
    },
    alt() {
      let alt = 'Logistimatics';
      if (is_b2b_platform) {
        alt = 'GPX';
      }

      if (this.forbidden) {
        alt += ' Forbidden';
      }

      return alt;
    },
  },
};
</script>
